import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgModule } from '@angular/core';
import { NgbCarouselModule, NgbModalModule, NgbDropdown, NgbDropdownMenu, NgbDropdownToggle, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';

import { environment } from '../environments/environment';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DefaultModule } from './layouts/default/default.module';
import { MyaccountModule } from './layouts/myaccount/myaccount.module';
import { QuickLookComponent } from './products/quick-look/quick-look.component';
import { CalculatedResultComponent } from './calculator/calculated-result/calculated-result.component';
import { FormsModule } from '@angular/forms';
import { AuthGuard } from './shared/services/auth-guard.service';

@NgModule({
  declarations: [
    AppComponent,
    QuickLookComponent
  ],
  imports: [
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    DefaultModule,
    MyaccountModule,
    AngularFireAuthModule,
    NgbCarouselModule,
    NgbModalModule,
    NgbDropdownModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    FormsModule
  ],
  providers: [AuthGuard],
  bootstrap: [AppComponent],
  entryComponents:[QuickLookComponent,CalculatedResultComponent]
})
export class AppModule { }
